import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule, MatMiniFabButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { Chat } from 'src/app/models/ai-chat-models/chat.model';
import { ChatDialogComponent } from '../chat-dialog/chat-dialog.component';

@Component({
    selector: 'app-chat-header',
    templateUrl: './chat-header.component.html',
    styleUrls: ['./chat-header.component.scss'],
    imports: [
        MatToolbarModule,
        MatButtonModule,
        MatMiniFabButton,
        MatIconModule,
        AsyncPipe,
        MatTooltipModule,
    ],
    standalone: true,
})
export class ChatHeaderComponent {
    @Input() currentChat: Observable<Chat>;
    protected _displayThreadName: boolean = true;
    @Output() displayThreadMenu: EventEmitter<void> = new EventEmitter<void>();
    @Output() openDialogEvent = new EventEmitter<boolean>();

    constructor(private dialog: MatDialog) {}

    get displayThreadName(): boolean {
        return this._displayThreadName;
    }

    set displayThreadName(value: boolean) {
        this._displayThreadName = value;
    }

    openChatDialog(): void {
        this.openDialogEvent.emit(false);
        const dialogRef = this.dialog.open(ChatDialogComponent, {
            maxWidth: '100vw',
            panelClass: 'resizability',
            data: { chat: this.currentChat },
        });

        dialogRef.afterClosed().subscribe(() => {
            this.openDialogEvent.emit(true);
        });
    }
}
